import { Box, Button, ButtonBase, Checkbox, Collapse, Dialog, DialogContent, Divider, IconButton, ImageList, ImageListItem, ImageListItemBar, TextField, Typography } from "@mui/material";
import AddPhotoAlternateRounded from "@mui/icons-material/AddPhotoAlternateRounded";
import useCompactLayout from "hooks/useCompactLayout";

import { BoxFC, BoxFR } from "components/BoxCustom";
import { DialogFooter, DialogHeader } from "components/dialog/DialogHeader";
import PaperComponent from "components/PaperComponent";
import { GlobalStateContext } from "contexts/GlobalStateContext";
import React, { useMemo, useState } from "react";
import { useContext } from "react";
import { useEffect } from "react";
import { jobOrderApiNm, jobOrderColNm } from "constants/jobOrderConstant";
import dayjs from "dayjs";
import { useCallback } from "react";
import SaveButton from "components/buttons/SaveButton";
import { CloseRounded, CloudDownloadRounded, DeleteForeverRounded, DeselectRounded, PhotoRounded, SaveRounded
  , SelectAllRounded } from "resource/muiImport";
import JSZip from 'jszip'
import { saveAs } from 'file-saver'
import { alertConfirm, alertConfirmDelete, alertSuccess, alertWarning } from "components/Alert";
import DriveFileMoveIcon from '@mui/icons-material/DriveFileMove';
import { containerNoCheck } from "utils";
import AddButton from "components/buttons/AddButton";
import AddJobOrderFileDialog from "../DailyJob/AddJobOrderFileDialog";
import { blueGrey, grey } from "@mui/material/colors";
import FullScreenImage from "pages/FullScreenImage/FullScreenImage";

const initDialogData = { ContNo: "", SealNo: "", TareWt: "" }

const parseOcr = (ocrTxt) => {
  try {
    return JSON.parse(ocrTxt) || {}
  } catch (e) {
    return {}
  }
}

/** Icon + caption button of the touch-layout selection bar. */
const BarButton = ({ icon, label, onClick, disabled }) => (
  <ButtonBase onClick={onClick} disabled={disabled} sx={{
    flexDirection: "column", gap: 0.25, minWidth: 64, minHeight: 52, px: 1, borderRadius: 2, color: "inherit",
    "&.Mui-disabled": { opacity: 0.5 }, "&.Mui-focusVisible": { outline: "2px solid white" }
  }}>
    {icon}
    <Typography sx={{ fontSize: 12, lineHeight: 1.2 }}>{label}</Typography>
  </ButtonBase>
)

const JobOrderImageDialog = ({ dialogOpen, setDialogOpen, onFinish, selectedId, contNo, isFromSubcontract }) => {

  const { ax, setTargetTimestamp, setBadge } = useContext(GlobalStateContext)
  const isCompact = useCompactLayout()

  const [jobOrdFiles, setJobOrdFiles] = useState([])
  const [dialogData, setDialogData] = useState({ ...initDialogData })
  const [isShowMoveImage, setIsShowMoveImage] = useState(false);
  const [moveJobOrdId, setMoveJobOrdId] = useState("")
  const [addJobOrderFileDialogOpen, setAddJobOrderFileDialogOpen] = useState(false)
  const [curImage, setCurImage] = useState("")
  const [downloading, setDownloading] = useState(false)

  const isSelectedAll = useMemo(() => {
    return jobOrdFiles.length > 0 && jobOrdFiles.every(item => !item.checked)
  }, [jobOrdFiles])
  const textFieldProp = useCallback((name) => ({
    variant: "outlined",
    size: "small",
    name: name,
    label: jobOrderColNm[name],
    value: dialogData[name] || "",
    sx: { width: 250 },
    onChange: (e) => {
      setDialogData(o => ({ ...o, [name]: e.target.value }))
    },
    onBlur: (e) => {
      const value = e.target.value.toUpperCase();
      if (name === "ContNo") {
        containerNoCheck(value)
      }
      setDialogData(o => ({ ...o, [name]: value }))
    }
  }), [dialogData])

  const getData = useCallback(() => {
    ax.post(jobOrderApiNm.getJobOrderFile, { JobOrdIds: selectedId }).then(value => {
      if (value.data && value.data.length > 0) {
        const files = value.data
        let contNo = "";
        let sealNo = "";
        let tareWt = "";
        for (const file of files) {
          if (file.OCRTxt) {
            if (contNo === "" || sealNo === "" || tareWt === "") {

              try {
                const ocrObj = JSON.parse(file.OCRTxt)

                if (ocrObj.ContNo && contNo === "") contNo = ocrObj.ContNo
                if (ocrObj.SealNo && sealNo === "") sealNo = ocrObj.SealNo
                if (ocrObj.TareWt && tareWt === "") tareWt = ocrObj.TareWt
              } catch (e) {

              }
            } else {
              break;
            }
          }

          file.checked = false;
        }
        if (contNo !== "" || sealNo !== "" || tareWt !== "") {
          setDialogData({
            ContNo: contNo,
            SealNo: sealNo,
            TareWt: tareWt
          })
        }
        setJobOrdFiles(files)
      }
    })
  }, [ax, selectedId])
  const handleImageDelete = useCallback((file) => () => {
    alertConfirmDelete(() => {
      ax.post(jobOrderApiNm.deleteJobOrderFile, { JobOrdFileId: file.JobOrdFileId, getArgs: { JobOrdId: selectedId } }).then(value => {
        if (value.data) {
          if (value.data.length > 0) {
            setJobOrdFiles(value.data[0].Files)
          } else {
            setJobOrdFiles([])
            setDialogOpen(false);
            onFinish();
          }
        }
      })
    })
  }, [ax, selectedId, onFinish, setDialogOpen])

  const handleConfirmMoveImageClick = useCallback(() => {

    const jobOrdFileIds = jobOrdFiles.filter(item => item.checked).map(item => item.JobOrdFileId)
    if (jobOrdFileIds.length === 0) {
      alertWarning("กรุณาเลือกรูปก่อน")
      return
    }
    if (moveJobOrdId.trim().length === 0) {
      alertWarning("กรุณาระบุเลขที่ใบงาน")
      return
    }
    const postData = {
      JobOrdId: moveJobOrdId,
      JobOrdFileIds: jobOrdFileIds,
      getArgs: { JobOrdId: selectedId }
    }

    ax.post(jobOrderApiNm.moveJobOrderFile, postData).then(value => {
      if (value.data) {
        if (value.data.length > 0) {
          setJobOrdFiles(value.data[0].Files)
          setIsShowMoveImage(false)
          setMoveJobOrdId("");
        } else {
          setJobOrdFiles([])
          setDialogOpen(false);
          onFinish();
        }
        alertSuccess("ย้ายรูปเรียบร้อยแล้ว")
      }
    })
  }, [ax, moveJobOrdId, jobOrdFiles, onFinish, selectedId, setDialogOpen])

  const confirmSave = useCallback(() => {
    const jsondata = {
      JobOrdId: selectedId,
      ColValues: {
        ContNo: dialogData.ContNo,
        SealNo: dialogData.SealNo,
        TareWt: dialogData.TareWt,
      },
      LogRmk: "แก้ไขข้อมูลตู้",
      withBadge: 1
    }
    ax.post(jobOrderApiNm.updateJobOrderColumn, jsondata).then(value => {

      if (value.data) {
        setTargetTimestamp(dayjs())
        setDialogOpen(false)
        setBadge(o => {
          const newData = { ...o, jobOrderImage: value.data.badgeNum }
          localStorage.setItem("badgeData", JSON.stringify(newData))
          return newData
        })
        onFinish()
      }
    })
  }, [ax, dialogData, onFinish, selectedId, setDialogOpen, setTargetTimestamp, setBadge])

  const handleSave = useCallback(() => {
    let msg = ""

    if (!containerNoCheck(dialogData.ContNo, false)) {
      msg += "หมายเลขตู้ไม่ถูกต้อง"
    }

    if (contNo !== "" && msg === "") {
      msg += "ใบงานนี้มีหมายเลขตู้อยู่แล้ว ต้องการแทนที่ด้วยหมายเลขตู้ใหม่หรือไม่"
    } else if (contNo !== "" && msg !== "") {
      msg += " และใบงานนี้มีหมายเลขตู้อยู่แล้ว ต้องการแทนที่ด้วยหมายเลขตู้ใหม่หรือไม่"
    } else if (contNo === "" && msg !== "") {
      msg += " ต้องการบันทึกหรือไม่"
    }
    if (msg !== "") {
      alertConfirm(msg, confirmSave)

    } else {
      confirmSave()
    }

  }, [contNo, confirmSave, dialogData.ContNo])

  const handleMoveButtonClick = useCallback(() => {
    setIsShowMoveImage(o => {
      const result = !o;
      if (!result) {
        setMoveJobOrdId("")
      }
      return result;
    })
  }, [])

  const handleMoveJobOrdIdChange = useCallback((e) => {
    setMoveJobOrdId(e.target.value)
  }, [])

  const handleCheckboxChagne = useCallback((item) => (e) => {
    item.checked = e.target.checked
    setJobOrdFiles(o => [...o])
  }, [])

  const handleAddFile = useCallback(() => {
    setAddJobOrderFileDialogOpen(true)
  }, [])

  const localOnFinish = useCallback(() => {
    getData()
  }, [getData])

  const handleSelctAll = useCallback(() => {
    setJobOrdFiles(o => o.map(item => ({ ...item, checked: isSelectedAll })))
  }, [isSelectedAll])

  const selectedCount = useMemo(() => jobOrdFiles.filter(i => i.checked).length, [jobOrdFiles])
  const allChecked = useMemo(() => jobOrdFiles.length > 0 && jobOrdFiles.every(i => i.checked), [jobOrdFiles])

  const handleDownloadSelected = useCallback(async () => {
    if (downloading) return
    const targets = jobOrdFiles.filter(f => f.checked)
    if (targets.length === 0) return
    setDownloading(true)
    try {
      const zip = new JSZip()
      const folder = zip.folder(`job-order-${selectedId}`)
      for (const file of targets) {
        const src = `/file/job-order/${selectedId}/${file.FileNm}`
        try {
          const res = await fetch(src, { credentials: 'include' })
          if (!res.ok) throw new Error(`HTTP ${res.status}`)
          const buf = await res.arrayBuffer()
          folder.file(file.FileNm, buf, { binary: true })
        } catch (e) {
          // continue on error for individual files
          // eslint-disable-next-line no-console
          console.error('Failed to fetch file for zip', file.FileNm, e)
        }
      }
      const zipBlob = await zip.generateAsync({ type: 'blob', compression: 'STORE' })
      const name = targets.length === jobOrdFiles.length ? `job-order-${selectedId}.zip` : `job-order-${selectedId}-${targets.length}.zip`
      saveAs(zipBlob, name)
    } finally {
      setDownloading(false)
    }
  }, [downloading, jobOrdFiles, selectedId])

  useEffect(() => {
    if (dialogOpen) {
      getData()
    } else {
      setDialogData(initDialogData)
      setJobOrdFiles([])
      setCurImage("")
    }
  }, [getData, dialogOpen])

  if (isCompact) {
    const clearSelection = () => setJobOrdFiles(o => o.map(item => ({ ...item, checked: false })))
    return (
      <Dialog open={dialogOpen} fullScreen aria-labelledby="joi-compact-title"
        onClose={() => setDialogOpen(false)}
        PaperProps={{ sx: { bgcolor: blueGrey[50] } }}>
        <Box sx={{
          display: "flex", alignItems: "center", gap: 0.5, px: 0.5, pb: 0.5,
          pt: "calc(4px + env(safe-area-inset-top))", bgcolor: "primary.main", color: "primary.contrastText"
        }}>
          <IconButton color="inherit" aria-label="ปิด" onClick={() => setDialogOpen(false)}><CloseRounded /></IconButton>
          <Box flex={1} minWidth={0}>
            <Typography id="joi-compact-title" noWrap sx={{ fontWeight: 700, fontSize: 17, lineHeight: 1.3 }}>
              รูปภาพใบงาน {selectedId}
            </Typography>
            <Typography noWrap sx={{ fontSize: 13, opacity: 0.85 }}>
              {jobOrdFiles.length} รูป
              {contNo ? <Box component="span" sx={{ ml: 1.5 }}>{contNo}</Box> : null}
            </Typography>
          </Box>
          <Button color="inherit" startIcon={<AddPhotoAlternateRounded />} onClick={handleAddFile} sx={{ minHeight: 40 }}>
            เพิ่มรูป
          </Button>
        </Box>

        <Box sx={{ flex: 1, overflowY: "auto", p: 1 }}>
          {jobOrdFiles.length === 0 ?
            <BoxFC sx={{ gap: 1.5, alignItems: "center", justifyContent: "center", height: "100%", textAlign: "center", p: 3 }}>
              <PhotoRounded sx={{ fontSize: 48, color: grey[500] }} />
              <Typography sx={{ color: "text.secondary" }}>ยังไม่มีรูปในใบงานนี้</Typography>
              <Button variant="contained" startIcon={<AddPhotoAlternateRounded />} onClick={handleAddFile} sx={{ minHeight: 44 }}>
                เพิ่มรูป
              </Button>
            </BoxFC>
            :
            <>
              <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                <Typography sx={{ fontSize: 13, color: "text.secondary", flex: 1 }}>แตะรูปเพื่อดูขนาดเต็ม</Typography>
                <Button size="small" onClick={handleSelctAll} sx={{ minHeight: 36 }}>
                  {isSelectedAll ? "เลือกทั้งหมด" : "ยกเลิกเลือก"}
                </Button>
              </Box>
              <Box sx={{
                display: "grid", gap: 1,
                gridTemplateColumns: { xs: "repeat(2, minmax(0, 1fr))", sm: "repeat(3, minmax(0, 1fr))", md: "repeat(4, minmax(0, 1fr))" }
              }}>
                {jobOrdFiles.map(file => {
                  const src = `/file/job-order/${selectedId}/${file.FileNm}`
                  const ocrObj = parseOcr(file.OCRTxt)
                  return (
                    <Box key={file.FileNm} sx={{
                      position: "relative", bgcolor: "background.paper", borderRadius: 2, overflow: "hidden",
                      outline: file.checked ? "3px solid" : "none", outlineColor: "primary.main", outlineOffset: -3
                    }}>
                      <ButtonBase onClick={() => setCurImage(src)} aria-label={`ดูรูป ${file.Label || ""}`}
                        sx={{ display: "block", width: "100%", aspectRatio: "4 / 3", bgcolor: grey[300] }}>
                        <img alt={file.Label} src={src} loading="lazy"
                          style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }} />
                      </ButtonBase>
                      <Checkbox checked={!!file.checked} onChange={handleCheckboxChagne(file)}
                        inputProps={{ "aria-label": `เลือกรูป ${file.Label || ""}` }}
                        sx={{
                          position: "absolute", top: 4, left: 4, p: 0.75, borderRadius: 1.5,
                          bgcolor: "rgba(255,255,255,0.85)", "&:hover": { bgcolor: "white" }
                        }} />
                      <IconButton aria-label={`ลบรูป ${file.Label || ""}`} onClick={handleImageDelete(file)}
                        sx={{
                          position: "absolute", top: 4, right: 4, color: "white", bgcolor: "rgba(0,0,0,0.55)",
                          "&:hover": { bgcolor: "rgba(0,0,0,0.75)" }
                        }}>
                        <DeleteForeverRounded fontSize="small" />
                      </IconButton>
                      <Box sx={{ px: 1, py: 0.75 }}>
                        <Typography noWrap sx={{ fontWeight: 600, fontSize: 14 }}>{file.Label}</Typography>
                        <Typography noWrap sx={{ fontSize: 12, color: "text.secondary" }}>
                          {file.ModAccNNm} {dayjs(file.AddTm).format("DD/MM HH:mm")}
                        </Typography>
                        {Object.keys(ocrObj).map(key => (
                          <Typography key={key} noWrap sx={{ fontSize: 12 }}>{key}: {ocrObj[key]}</Typography>
                        ))}
                      </Box>
                    </Box>
                  )
                })}
              </Box>
            </>
          }
        </Box>

        {selectedCount > 0 ?
          <Box sx={{
            display: "flex", alignItems: "center", gap: 0.5, flexWrap: "wrap", px: 1, pt: 0.5,
            pb: "calc(4px + env(safe-area-inset-bottom))", bgcolor: "grey.900", color: "common.white"
          }}>
            <IconButton color="inherit" aria-label="ยกเลิกการเลือก" onClick={() => { clearSelection(); setIsShowMoveImage(false); setMoveJobOrdId("") }}>
              <CloseRounded />
            </IconButton>
            <Typography sx={{ fontWeight: 700, whiteSpace: "nowrap" }}>{selectedCount} รูป</Typography>
            <Box flex={1} />
            {isShowMoveImage ?
              <BoxFR sx={{ gap: 0.5, py: 0.5 }}>
                <TextField size="small" placeholder="ย้ายไปใบงานเลขที่" type="number" autoFocus
                  inputProps={{ inputMode: "numeric", "aria-label": "ย้ายไปใบงานเลขที่" }}
                  value={moveJobOrdId} onChange={handleMoveJobOrdIdChange}
                  sx={{ width: 150, bgcolor: "white", borderRadius: 1 }} />
                <Button variant="contained" onClick={handleConfirmMoveImageClick} sx={{ minHeight: 40 }}>ย้าย</Button>
                <Button color="inherit" onClick={handleMoveButtonClick}>ยกเลิก</Button>
              </BoxFR>
              :
              <>
                <BarButton icon={<CloudDownloadRounded />} label={downloading ? "กำลังโหลด" : "ดาวน์โหลด"}
                  onClick={handleDownloadSelected} disabled={downloading} />
                {!isFromSubcontract ?
                  <BarButton icon={<DriveFileMoveIcon />} label="ย้ายไปใบงานอื่น" onClick={handleMoveButtonClick} />
                  : null}
              </>
            }
          </Box>
          :
          <Box sx={{
            display: "grid", gap: 1, px: 1, pt: 1, pb: "calc(8px + env(safe-area-inset-bottom))",
            bgcolor: "background.paper", borderTop: 1, borderColor: "divider",
            gridTemplateColumns: { xs: "repeat(2, minmax(0, 1fr))", sm: "repeat(3, minmax(0, 1fr)) auto" }
          }}>
            <Typography sx={{ gridColumn: "1 / -1", fontSize: 13, color: "text.secondary" }}>
              ตรวจข้อมูลตู้ที่อ่านจากรูปก่อนบันทึก
            </Typography>
            <TextField {...textFieldProp("ContNo")} sx={{ width: "100%" }} />
            <TextField {...textFieldProp("SealNo")} sx={{ width: "100%" }} />
            <TextField {...textFieldProp("TareWt")} sx={{ width: "100%" }} inputProps={{ inputMode: "decimal" }} />
            <Button variant="contained" startIcon={<SaveRounded />} onClick={handleSave} sx={{ minHeight: 40 }}>
              บันทึกข้อมูลตู้
            </Button>
          </Box>
        }

        <Dialog open={!!curImage} fullScreen onClose={() => setCurImage("")} aria-label="รูปขนาดเต็ม">
          <Box position="relative" height="100%">
            {/* curImage is "" while the dialog plays its close animation; FullScreenImage needs a url */}
            {curImage ? <FullScreenImage linkUrl={curImage} height="100%" /> : null}
            <IconButton aria-label="ปิดรูป" onClick={() => setCurImage("")}
              sx={{
                position: "absolute", top: "calc(12px + env(safe-area-inset-top))", right: 12, color: "white",
                bgcolor: "rgba(0,0,0,0.6)", "&:hover": { bgcolor: "rgba(0,0,0,0.75)" }
              }}>
              <CloseRounded />
            </IconButton>
          </Box>
        </Dialog>
        <AddJobOrderFileDialog
          selectedId={selectedId}
          dialogOpen={addJobOrderFileDialogOpen}
          setDialogOpen={setAddJobOrderFileDialogOpen}
          onFinish={localOnFinish} />
      </Dialog>
    )
  }

  return (
    <Dialog
      open={dialogOpen}
      onClose={(e, reason) => {
        if (reason === "backdropClick") return
        setDialogOpen(false)
      }}
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-dialog-title"
      fullWidth maxWidth='xl'
      PaperProps={{
        style: {
          maxHeight: 900,
          minHeight: 900,
        }
      }} >
      <DialogHeader handleDialogClose={() => setDialogOpen(false)}
        title={`รูปภาพ (${jobOrdFiles.length} รูป)`}
        onDeleteClick={null}
      >
        <Button
          variant="contained"
          color="secondary"
          onClick={handleDownloadSelected}
          disabled={downloading || selectedCount === 0}
          sx={{ ml: 1 }}
        >
          <CloudDownloadRounded sx={{ mr: 1 }} />
          {downloading
            ? 'Downloading…'
            : allChecked
              ? 'Download All'
              : `Download ${selectedCount} images`}
        </Button>
      </DialogHeader>
      <DialogContent sx={{ pb: 0 }}>
        <BoxFR mt={1} height="100%" sx={{ alignItems: "stretch" }}>
          <BoxFC sx={{ gap: 1, width: 550 }}>
            <BoxFR>
              <AddButton onClick={handleAddFile} >เพิ่มรูป</AddButton>
              <Button variant="contained" onClick={handleSelctAll} sx={{ width: 160 }}>
                {isSelectedAll ? <SelectAllRounded sx={{ mr: 1 }} /> : <DeselectRounded sx={{ mr: 1 }} />}
                {isSelectedAll ? "เลือกทั้งหมด" : "ไม่เลือกทั้งหมด"}</Button>
              {!isFromSubcontract ?
                <BoxFR>
                  <Button variant="contained" onClick={handleMoveButtonClick}> <DriveFileMoveIcon sx={{ mr: 1 }} /> ย้ายรูปที่เลือกไปใบงานอื่น</Button>
                  <Collapse orientation="horizontal" in={isShowMoveImage}>
                    <BoxFR>
                      <TextField
                        size="small"
                        label="เลขที่ใบงาน"
                        type="number"
                        value={moveJobOrdId}
                        onChange={handleMoveJobOrdIdChange} sx={{ width: 150 }} />
                      <Button variant="contained" sx={{ width: 120 }} onClick={handleConfirmMoveImageClick}>ยื่นยันการย้าย</Button>
                    </BoxFR>
                  </Collapse>
                </BoxFR> : null
              }
            </BoxFR>
            <ImageList cols={2} rowHeight={300} sx={{ width: "100%", m: 0, height: 610, bgcolor: blueGrey[50], p: 1, borderRadius: 1 }}>
              {jobOrdFiles.map(file => {

                const src = `/file/job-order/${selectedId}/${file.FileNm}`
                // const linkUrl = src.replaceAll("/", "~")
                const ocrObj = JSON.parse(file.OCRTxt) || {}

                return (
                  <ImageListItem key={file.FileNm} sx={{ position: "relative", "& .MuiImageListItemBar-root": { px: 5 } }} >
                    <img alt={file.Label} src={src} loading="lazy" onClick={() => { setCurImage(src) }} style={{ height: 300 }} />

                    <ImageListItemBar
                      sx={{ px: 6, "& .MuiImageListItemBar-titleWrap": { px: 0, py: 0.5 }, }}
                      title={`${file.Label}`}
                      subtitle={
                        <BoxFC sx={{ gap: 0.5 }}>
                          <span>by: {file.ModAccNNm} {dayjs(file.AddTm).format("DD/MM/YYYY HH:mm")}</span>
                          {Object.keys(ocrObj).map(key => (<span key={key}>{key}: {ocrObj[key]}</span>))}
                          {/* <div>{file.OCRTxt || "-"}</div> */}
                        </BoxFC>
                      }
                      // position="below"
                      actionIcon={
                        <BoxFR position="absolute" top={0} left={0} width="100%">
                          <Checkbox
                            checked={file.checked}
                            onChange={handleCheckboxChagne(file)}
                            sx={{
                              p: 0, mt: 0, ml: 1,
                              color: "white",
                              '&.Mui-checked': {
                                color: "white",
                              },
                            }}
                          />
                          <Box flex={1} />
                          <IconButton onClick={handleImageDelete(file)}><DeleteForeverRounded sx={{ p: 0, mt: 0, color: "white" }} /></IconButton>
                        </BoxFR>}
                      actionPosition="left"
                    />
                  </ImageListItem>
                )
              })}
            </ImageList>
            <Divider />
            <BoxFC sx={{ gap: 1 }} mt={0}>
              <BoxFR>
                <TextField  {...textFieldProp("ContNo")} />
                <TextField  {...textFieldProp("SealNo")} />
              </BoxFR>
              <BoxFR>
                <TextField  {...textFieldProp("TareWt")} />
                <SaveButton onClick={handleSave} sx={{ width: 250 }} />
              </BoxFR>
            </BoxFC>
          </BoxFC>
          <BoxFC flex={1} bgcolor={blueGrey[50]} borderRadius={1} height={770} width="100%"
            sx={{ justifyContent: "center", alignItems: "center" }}>
            {curImage ?
              <FullScreenImage linkUrl={curImage} />
              // <img alt="รูปภาพที่เลือก"
              //   src={curImage}
              //   loading="lazy"
              //   style={{ height: 815, width: "100%", objectFit: "contain" }}
              //   onClick={() => window.open(`/image/${curImage.replaceAll("/", "~")}`)} />
              :
              <BoxFC sx={{ gap: 0 }} justifyContent="center" alignItems="center" width="100%" height="100%">
                <PhotoRounded sx={{ fontSize: 50, color: grey[500] }} />
                <Typography variant="h6" sx={{ color: grey[500] }}>กรุณาเลือกรูป</Typography>
              </BoxFC>
            }

          </BoxFC>
        </BoxFR>

        <AddJobOrderFileDialog
          selectedId={selectedId}
          dialogOpen={addJobOrderFileDialogOpen}
          setDialogOpen={setAddJobOrderFileDialogOpen}
          onFinish={localOnFinish} />
      </DialogContent >
      <DialogFooter okText=""
        handleDialogClose={() => setDialogOpen(false)}
        handleDialogOk={null} />
    </Dialog >
  )
}

export default React.memo(JobOrderImageDialog)